import React, { useContext } from 'react'
import './ExtraQuestions.css'
import {LanguageContext} from "../../context/languageContext";
import { perspectiveQuestionsFactory } from '../../Helper_functions/Languages/LanguageSelector';
import { LanguageIdContext } from '../../context/languageIdContext';
export default function ExtraQuestions() {
// import context
  const {languageId} = useContext(LanguageIdContext);

  return (
    <div className='main_body'>
        <h4>{perspectiveQuestionsFactory(languageId,1).title}</h4>
        <p>{perspectiveQuestionsFactory(languageId,1).question}</p><br/>
        <h4>{perspectiveQuestionsFactory(languageId,2).title}</h4>
        <p>{perspectiveQuestionsFactory(languageId,2).question}</p><br/>
        <h4>{perspectiveQuestionsFactory(languageId,3).title}</h4>
        <p>{perspectiveQuestionsFactory(languageId,3).question}</p><br/>
        <h4>{perspectiveQuestionsFactory(languageId,4).title}</h4>
        <p>{perspectiveQuestionsFactory(languageId,4).question}</p><br/>
        <h4>{perspectiveQuestionsFactory(languageId,5).title}</h4>
        <p>{perspectiveQuestionsFactory(languageId,5).question}</p><br/>
        
    </div>
  )
}
